import React from "react";
import Button from '@mui/material/Button';

const UserInfo = ({ user, onLogout }) => {
  return (
    <div className="bg-gray-100 p-4 flex justify-between items-center">
      <div>
        <p className="font-bold">{user?.email}</p>
        <p className="text-sm text-gray-500">Logged in</p>
      </div>
      <div>
        <Button 
          variant="outlined"
          color="secondary"
          onClick={onLogout}
        >
          Logout
        </Button>
      </div>
    </div>
  );
};

export default UserInfo;